var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommuter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0665 2.79688C15.8185 2.79688 15.6172 2.99813 15.6172 3.24609C15.6172 3.49406 15.8185 3.69531 16.0665 3.69531C16.3144 3.69531 16.5157 3.49406 16.5157 3.24609C16.5157 2.99813 16.3144 2.79688 16.0665 2.79688Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87897 2.79688C8.631 2.79688 8.42975 2.99813 8.42975 3.24609C8.42975 3.49406 8.631 3.69531 8.87897 3.69531C9.12694 3.69531 9.32819 3.49406 9.32819 3.24609C9.32819 2.99813 9.12694 2.79688 8.87897 2.79688Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8157 23.2401L18.8431 20.1347C20.044 20.0916 21.0079 19.1019 21.0079 17.8906V4.56096C21.0079 3.83515 20.7542 3.12638 20.2935 2.56517C19.8324 2.00409 19.1865 1.61745 18.475 1.47671C16.8807 1.16037 15.2483 1 13.6232 1H11.25C9.70435 1 8.09439 1.14806 6.46526 1.47366C5.00058 1.76668 3.93755 3.06362 3.93755 4.55736V17.8906C3.93755 19.1121 4.91774 20.1082 6.13274 20.1354L3.12662 23.2382C3.00106 23.3678 2.96521 23.5599 3.03561 23.7259C3.10591 23.8921 3.26884 24 3.44925 24H6.66116C6.80518 24 6.94044 23.931 7.02494 23.8143L8.3876 21.9336H16.5978L17.9605 23.8144C18.0449 23.931 18.1803 24 18.3242 24H21.4912C21.6711 24 21.8337 23.8926 21.9043 23.7272C21.975 23.5617 21.9401 23.3701 21.8157 23.2401ZM4.83598 17.8906V4.55736C4.83598 3.49033 5.5953 2.56396 6.6414 2.35462C8.10778 2.06155 9.65727 1.89844 11.2499 1.89844H13.6232C15.1897 1.89844 16.7632 2.05301 18.3003 2.35794C18.8086 2.45852 19.2699 2.7347 19.5991 3.13536C19.9282 3.5362 20.1094 4.04247 20.1094 4.56091V17.8906C20.1094 18.6337 19.5048 19.2383 18.7617 19.2383H6.1836C5.44054 19.2383 4.83598 18.6337 4.83598 17.8906ZM6.43192 23.1016H4.50994L7.38238 20.1367H8.58009L6.43192 23.1016ZM9.03856 21.0352L9.68952 20.1367H15.2959L15.9468 21.0352H9.03856ZM18.5535 23.1016L16.4054 20.1367H17.6014L20.4394 23.1016H18.5535Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7618 4.59375H6.18365C5.9356 4.59375 5.73444 4.79491 5.73444 5.04297V12.5C5.73444 12.7481 5.9356 12.9492 6.18365 12.9492H18.7618C19.0098 12.9492 19.211 12.7481 19.211 12.5V5.04297C19.211 4.79491 19.0098 4.59375 18.7618 4.59375ZM12.0235 12.0508H6.63287V5.49219H12.0235V12.0508ZM18.3126 12.0508H12.9219V5.49219H18.3126V12.0508Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2696 2.79688H10.6758C10.4278 2.79688 10.2266 2.99804 10.2266 3.24609C10.2266 3.49415 10.4278 3.69531 10.6758 3.69531H14.2696C14.5177 3.69531 14.7188 3.49415 14.7188 3.24609C14.7188 2.99804 14.5177 2.79688 14.2696 2.79688Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 14.2969C16.4233 14.2969 15.6172 15.103 15.6172 16.0938C15.6172 17.0845 16.4233 17.8906 17.4141 17.8906C18.4049 17.8906 19.211 17.0845 19.211 16.0938C19.211 15.103 18.4049 14.2969 17.4141 14.2969ZM17.4141 16.9922C16.9187 16.9922 16.5157 16.5891 16.5157 16.0938C16.5157 15.5984 16.9187 15.1953 17.4141 15.1953C17.9095 15.1953 18.3126 15.5984 18.3126 16.0938C18.3126 16.5891 17.9095 16.9922 17.4141 16.9922Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53131 14.2969C6.54051 14.2969 5.73444 15.103 5.73444 16.0938C5.73444 17.0845 6.54056 17.8906 7.53131 17.8906C8.52211 17.8906 9.32819 17.0845 9.32819 16.0938C9.32819 15.103 8.52211 14.2969 7.53131 14.2969ZM7.53131 16.9922C7.03591 16.9922 6.63287 16.5891 6.63287 16.0938C6.63287 15.5984 7.03591 15.1953 7.53131 15.1953C8.02671 15.1953 8.42975 15.5984 8.42975 16.0938C8.42975 16.5891 8.02671 16.9922 7.53131 16.9922Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2696 14.7461H10.6758C10.4278 14.7461 10.2266 14.9473 10.2266 15.1953C10.2266 15.4434 10.4278 15.6445 10.6758 15.6445H14.2696C14.5177 15.6445 14.7188 15.4434 14.7188 15.1953C14.7188 14.9473 14.5177 14.7461 14.2696 14.7461Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2696 16.543H10.6758C10.4278 16.543 10.2266 16.7441 10.2266 16.9922C10.2266 17.2402 10.4278 17.4414 10.6758 17.4414H14.2696C14.5177 17.4414 14.7188 17.2402 14.7188 16.9922C14.7188 16.7441 14.5177 16.543 14.2696 16.543Z",
    fill: "#22222D",
    stroke: "#22222D",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuter);
export default __webpack_public_path__ + "static/media/commuter.f337baea.svg";
export { ForwardRef as ReactComponent };